import PropTypes from 'prop-types';

import { withRequirementTemplateBlueprint } from '../redux/blueprints/requirement-templates';

const blueprint = withRequirementTemplateBlueprint('dummy');

export default PropTypes.shape(Object.keys(blueprint)
  .filter(key => typeof blueprint[key] === 'function')
  .reduce((type, key) => ({ ...type, [key]: PropTypes.func }), {}));
